export default __webpack_public_path__ + "static/media/property_17.4676144a.png";